export default {
  headers: [{
    text: 'Project Name',
    align: 'left',
    value: 'name',
  },
  {
    text: 'Category',
    value: 'category',
  },
  {
    text: 'Type',
    value: 'projectType',
  },
  {
    text: 'Plan',
    value: 'plan',
  },
  {
    text: 'Current Stage',
    value: 'stage',
  },
  {
    text: 'Contact Point',
    value: 'contact',
  },
  {
    text: 'Start Date',
    value: 'startDate',
  },
  {
    text: 'End Date',
    value: 'endDate',
  },
  {
    text: 'Actions',
    value: 'actions',
    sortable: false,
    align: 'center',
  },
  ],
  options: {
    loadingText: 'Loading projects... Please wait',
    showSelect: true,
    itemsPerPage: 10,
  },
  actionItems: [{
    title: 'Manage Tasks',
    id: 'onTodoSelect',
    action: 'onTodoSelect',
    icon: 'mdi-bug-outline',
    match() {
      return true;
    },
  }, {
    title: 'Edit',
    id: 'onEdit',
    action: 'onEdit',
    icon: 'mdi-pencil',
    match() {
      return true;
    },
  }, {
    title: 'Delete',
    id: 'onDelete',
    action: 'onDelete',
    icon: 'mdi-delete-outline',
    match() {
      return true;
    },
  }],
  bulkActionItems: [{
    title: 'Delete',
    id: 'deleteAll',
    action: 'onMulitpleDelete',
  }],
};
